import { render, staticRenderFns } from "./DetailsLeft.vue?vue&type=template&id=2af833ee&scoped=true"
import script from "./DetailsLeft.vue?vue&type=script&lang=js"
export * from "./DetailsLeft.vue?vue&type=script&lang=js"
import style0 from "./DetailsLeft.vue?vue&type=style&index=0&id=2af833ee&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af833ee",
  null
  
)

export default component.exports